module.exports = __webpack_public_path__ + "img/ic_stars.3b0f2aaa.svg";